

export enum EditorModule {
  TASK = 'TASK',
  MARKDOWN = 'MARKDOWN',
  OKR = 'OKR',
  OKR_KEY_RESULT = 'OKR_KEY_RESULT',
  BLOG = 'BLOG',
}
